<template>
  <div>
    <core-modal-header>Review Image</core-modal-header>

    <core-modal-body>
      <p>Here's the final rendered image. Please review before we apply it.</p>
      <img :src="imageSrc" class="border border-gray-200 shadow" alt="Rendered Image" />
      <p v-if="errorMessage" class="mt-3 text-sm text-red-700 bg-red-50 border border-red-200 rounded p-3" role="alert">
        {{ errorMessage }}
      </p>
    </core-modal-body>

    <core-modal-footer>
      <u-button size="xl" color="charcoal" variant="soft" @click="modal.close()">Back to Editor</u-button>
      <u-button size="xl" @click="confirm" :loading="isSaving" :disabled="isSaving">{{actionText}}</u-button>
    </core-modal-footer>

  </div>
</template>

<script setup>

  const emit = defineEmits(['confirm']);
  const props = defineProps({
    exported: Object,
    actionText: {
      type: String,
      default: 'Save'
    },
    errorMessage: {
      type: String,
      default: ''
    },
    isSaving: {
      type: Boolean,
      default: false
    },
    modal: Object
  });

  const imageSrc = computed(() => URL.createObjectURL(props.exported))

  function confirm() {
    emit('confirm');
  }
</script>
